import axios from 'axios';
import { API_BASE_URL } from './config';

function encodeBase64(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

function decodeBase64(str) {
  return decodeURIComponent(escape(atob(str)));
}

export default {
  getToken() {
    return localStorage.getItem('token');
  },
  getTokenReceivedTime() {
    return parseInt(localStorage.getItem('tokenReceivedTime'), 10) || 0;
  },
  getStoredUsername() {
      return localStorage.getItem('username');
  },
  getStoredPassword() {
    const encodedPassword = localStorage.getItem('password');
    if (encodedPassword) {
      return decodeBase64(encodedPassword);
    }
    return null;
  },
  isTokenExpired() {
    const currentTime = Date.now();
    const tokenReceivedTime = this.getTokenReceivedTime();
    return currentTime - tokenReceivedTime > 50 * 60 * 1000;
  },
  storeToken(token) {
    localStorage.setItem('token', token);
    localStorage.setItem('tokenReceivedTime', Date.now());
  },
  storeUsername(username) {
      localStorage.setItem('username', username);
  },
  storePassword(password) {
    const encodedPassword = encodeBase64(password);
    localStorage.setItem('password', encodedPassword);
  },
  clearToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenReceivedTime');
  },
  async refreshToken() {
      const token = this.getToken();
  
      const credentials = {
        username: this.getStoredUsername(),
        password: this.getStoredPassword(),
        lifetime: 3600,
      };
  
      if (!token || this.isTokenExpired()) {
        try {
          const response = await axios.post(`${API_BASE_URL}/api/rest/v2/application/tokens`, credentials);
          const tokenData = response.data;
          const newToken = tokenData.tokens[0];
          this.storeToken(newToken);
          // axios.defaults.headers.common['X-Jobrouter-Authorization'] = `Bearer ${newToken}`;
        } catch (error) {
          console.error('Error:', error);
          throw error;
        }
    }
  }
};